import {
  Chart as ChartJS,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title,
  LinearScale,
  CategoryScale,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Error } from '../error';
import { useMemo } from 'react';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { getLineOptions } from './chart/options';
import { useCompassExercisesOverTime } from './hooks/useCompassExercisesOverTime';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';
import { SuspenseLoading } from '../loading';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend, Title);

export const CompassExercisesOverTime = () => {
  const { lineData, isMobile, error, isPending } = useCompassExercisesOverTime();
  const onOpenDialog = useReportingToolsStore((state) => state.onOpenDialog);
  const page = useReportingToolsStore((state) => state.page);
  const options = useMemo(() => getLineOptions(isMobile), [isMobile]);

  if (error) {
    return <Error error={error} />;
  }

  return (
    <div className="relative flex h-96 flex-col">
      {isPending && <SuspenseLoading />}
      <div className="flex items-center justify-start gap-4">
        <h2 className="!pb-1 text-sh-22-28 font-medium">{page?.compassExercisesOverTime?.title}</h2>
        <InformationCircleIcon
          className="h-6 w-6 cursor-pointer text-gray-400"
          onClick={() =>
            onOpenDialog({
              title: page?.compassExercisesOverTime?.dialogTitle || '',
              description: page?.compassExercisesOverTime?.dialogDescription || '',
            })
          }
        />
      </div>
      <p className="mb-sh-30 font-cadiz text-sh-xxs text-gray-500">
        {page?.compassExercisesOverTime?.briefDescription ||
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque'}
      </p>
      {lineData.datasets.length > 0 && <Line data={lineData} options={options} className="!m-0 !p-0" />}
      {lineData.datasets.length === 0 && (
        <div className="flex h-full flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200">
          <p className="text-sh-xs text-gray-500">{page?.compassExercisesOverTime?.noData}</p>
        </div>
      )}
    </div>
  );
};
